import { useEffect } from 'react';

import { notificationsService } from '@webtrader/core/services/notifications';
import { socketService } from '@webtrader/core/socket';
import { EUserMessageType, IUserReceiver } from '@webtrader/core/socket/topics/user';

export const useUserTopic = (traderSubscription?: string) => {
  useEffect(() => {
    if (!traderSubscription) {
      return () => {};
    }

    const onReceive: IUserReceiver = (message) => {
      if (!message) {
        return;
      }

      switch (message.M) {
        case EUserMessageType.NOTIFICATION:
          notificationsService.fetchNotificationSummary();
          break;
        default:
          break;
      }
    };

    socketService.topics().user.subscribe({
      traderSubscription,
      receiver: onReceive
    });

    return () => {
      socketService.topics().user.unsubscribe({
        traderSubscription,
        receiver: onReceive
      });
    };
  }, [traderSubscription]);
};
